<template>
    <ul class="nav nav-tabs conversions-tabs">
        <li class="nav-item">
            <router-link :to="'/statistic/conversions/country'" class="nav-link" exact><i class="fa fa-globe"></i> {{ $t('pages.by_country') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/conversions/offers'" class="nav-link" exact><i class="fa fa-briefcase"></i> {{ $t('pages.by_offers') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/conversions/period'" class="nav-link" exact><i class="fa fa-calendar-o"></i> {{ $t('pages.by_period') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/conversions/courier'" class="nav-link" exact><i class="fa fa-truck"></i> {{ $t('pages.by_couriers') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/conversions/graph'" class="nav-link" exact><i class="fa fa-area-chart"></i> {{ $t('pages.by_graph') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/conversions/buyout'" class="nav-link" exact><i class="fa fa-pie-chart"></i> {{ $t('pages.by_pieces') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/conversions/flypost'" class="nav-link" exact><i class="fa fa-shopping-cart"></i> {{ $t('pages.buyouts_flypost') }}</router-link>
        </li>
    </ul>
</template>

<script>
  export default {
    name: 'ConversionsTabs'
  }
</script>



// WEBPACK FOOTER //
// ConversionsTabs.vue?1053ebde